import { FormControlLabel, FormGroup, Popover } from "@mui/material";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import rgbHex from "rgb-hex";
import left_text from "../../Assets/Images/left_text.svg";
import left_text_selected from "../../Assets/Images/left_text_selected.svg";
import right_text from "../../Assets/Images/right_text.svg";
import right_text_selected from "../../Assets/Images/right_text_selected.svg";
import text_center from "../../Assets/Images/text_center.svg";
import text_center_selected from "../../Assets/Images/text_center_selected.svg";

import {
  changeItemProperties,
  deleteItem,
  setActiveId,
  setItem,
} from "../../Redux/WaterMarks/wateramarks";

import { ChromePicker } from "react-color";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/imageProperties.scss";
import { EnumAlign, fontList } from "../../Config/config";
import {
  setEnableTextShadowColor,
  setTextColor,
  setTextFont,
  setTextShadowColor,
} from "../../Redux/PreviousSettings/previousSettingsSlice";
import Stickers from "../Stickers/stickers";
import SwitchCustom from "../Switches/Switch";
import Templates from "../Template/templates";
import AlignmentRow from "./AlignmentRow";
import SlidersRow from "./SlidersRow";

const ImageProperties = forwardRef(
  (
    {
      setOpenSignature,
      setChoice,
      active,
      setActive,
      onFileChange,
      userSliceState,
      file,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [size, setSize] = useState(0);
    const [sizeScale, setSizeScale] = useState(0);
    const [rotation, setRotation] = useState(0);
    const [opacity, setopacity] = useState(1);
    const [image, setImage] = useState(null);
    const [font, setFont] = useState("Sans-serif");
    const [activeItem, setActiveItem] = useState(null);
    const [text, setTextValue] = useState("");
    const [currentText, setCurrentText] = useState(null);
    const [shadowColorEnable, setShadowColorEnable] = useState(false);
    const [color, setColor] = useState("#000000");
    const [shadowColor, setShadowColor] = useState("#000000");
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);

    const dispatch = useDispatch();

    const waterMarksState = useSelector((state) => state["watermarks"]);

    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
      // Optionally, you can set a timeout to automatically hide the component after a certain time
      const timeout = setTimeout(() => {
        setIsVisible(false);
      }, 3000); // 3000 milliseconds (3 seconds) in this example

      // Cleanup the timeout to avoid potential memory leaks
      return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
      if (currentText) setChoice(true);
      else setChoice(false);
    }, [currentText]);
    useEffect(() => {
      if (active === "text") {
        const desiredText = waterMarksState.items.filter(
          (item) =>
            item.id === waterMarksState.activeId &&
            item.type === "text" &&
            item.property === "text"
        );
        setCurrentText(desiredText[0]);
        if (desiredText.length <= 0) {
          setTextValue("");
        }
      } else if (active === "date") {
        const desiredText = waterMarksState.items.filter(
          (item) =>
            item.id === waterMarksState.activeId &&
            item.type === "text" &&
            item.property === "date"
        );
        setCurrentText(desiredText[0]);
        if (desiredText.length <= 0) {
          setTextValue("");
        }
      } else {
        setCurrentText(null);
        setTextValue("");
      }
    }, [waterMarksState, active]);

    useEffect(() => {
      if (active === "image" || active === "signature") {
        setActiveItem(waterMarksState.activeId);
        const desiredImage = waterMarksState.items.filter(
          (image) =>
            image.id === waterMarksState.activeId && image.type === "image"
        );
        setImage(desiredImage[0]);
        if (desiredImage[0] && desiredImage[0].property === "signature") {
          setOpenSignature(false);
          const createImageElement = new window.Image();
          createImageElement.src = desiredImage[0].src;
        }
      } else {
        setImage(null);
        setActiveItem("");
      }
    }, [waterMarksState, active]);

    useEffect(() => {
      if (image) {
        setChoice(true);
        setSize(image.scaleXTransform ? image.scaleXTransform : image.scaleX);
        setSizeScale(image.scaleX);
        setRotation(image.deg);
        setopacity(image.opacity);
      } else if (currentText) {
        setFont(currentText.font);
        setTextValue(currentText.src);
        setSize(
          currentText.scaleXTransform
            ? currentText.scaleXTransform
            : currentText.scaleX
        );
        setSizeScale(currentText.scaleX);
        setRotation(currentText.deg);
        setopacity(currentText.opacity);
        setColor(currentText.textColor);
        setShadowColor(currentText.shadowColor);
        setShadowColorEnable(currentText.enableShadowColor);
      }
    }, [image, currentText]);

    const sizeChanged = (value, choice) => {
      if (active === "image" || active === "signature") {
        if (image) {
          let propertiesToUpdate = {
            id: image.id,
            alignEnable: EnumAlign.None,
          };

          if (choice) {
            console.log("Choice 1");
            propertiesToUpdate = {
              ...propertiesToUpdate,
              scaleXSlide: value,
              scaleYSlide: value,
              alignEnable: EnumAlign.None,
            };
          } else if (!choice) {
            console.log("Choice 0");
            propertiesToUpdate = {
              // ...image,
              ...propertiesToUpdate,
              scaleX: value,
              scaleY: value,
              scaleXSlide: null,
              scaleYSlide: null,
              alignEnable: EnumAlign.None,
            };
          }
          console.log(propertiesToUpdate);
          dispatch(changeItemProperties(propertiesToUpdate));
        }
      } else if (active === "text" || active === "date") {
        if (currentText) {
          let propertiesToUpdate = {
            id: currentText.id,
            alignEnable: EnumAlign.None,
          };

          if (choice) {
            propertiesToUpdate = {
              ...propertiesToUpdate,
              scaleXSlide: value,
              scaleYSlide: value,
              alignEnable: EnumAlign.None,
            };
          } else {
            propertiesToUpdate = {
              ...currentText,
              ...propertiesToUpdate,
              scaleX: value,
              scaleY: value,
              scaleXSlide: null,
              scaleYSlide: null,
              alignEnable: EnumAlign.None,
            };
          }
          dispatch(changeItemProperties(propertiesToUpdate));
        }
      }
    };
    const rotate = (value) => {
      if (active === "image" || (active === "signature" && image !== null)) {
        if (image) {
          setRotation(value);
          dispatch(
            changeItemProperties({
              id: image.id,
              deg: value,
              alignEnable: EnumAlign.None,
            })
          );
        }
      } else if (active === "text" || active === "date")
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              deg: value,
              alignEnable: EnumAlign.None,
            })
          );
        }
    };

    const changeOpacity = (value) => {
      if (active === "image" || (active === "signature" && image)) {
        if (image) {
          setopacity(value);
          dispatch(
            changeItemProperties({
              id: image.id,
              opacity: value,
              alignEnable: EnumAlign.None,
            })
          );
        }
      } else if (active === "text" || active === "date")
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              opacity: value,
              alignEnable: EnumAlign.None,
            })
          );
        }
    };

    const handleChange = (event) => {
      event.preventDefault();
      setFont(event.target.value);
      dispatch(setTextFont(event.target.value));
      if (active === "text" || active === "date")
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              font: event.target.value,
            })
          );
        }
    };

    const addNewText = () => {
      if (text !== "") {
        dispatch(
          setItem({
            type: "text",
            property: "text",
            id: Date.now(),
            x: 50,
            y: 50,
            deg: 0,
            scaleX: 0.15,
            scaleY: 0.15,
            src: text,
            opacity: 1,
            textColor: color,
            font: font,
            shadowColor: shadowColor,
            enableShadowColor: shadowColorEnable,
          })
        );
        setTextValue("");
      }
    };
    useImperativeHandle(ref, () => ({
      addNewItem(event) {
        if (active === "image") {
          onFileChange(event);
        } else if (active === "text" || active === "date") {
          if (waterMarksState.activeId) {
            if (currentText) updateExiting(event);
            else addNewText();
          } else addNewText();
        }
      },
      deleteCurrentItem() {
        dispatch(
          deleteItem({
            id: waterMarksState.activeId,
          })
        );
        dispatch(setActiveId(""));
        setActive("");
      },
    }));

    const updateExiting = (event) => {
      if (active === "image") {
        onFileChange(event);
      } else if (active === "text" || active === "date") {
        if (currentText.type === "text")
          dispatch(
            changeItemProperties({
              id: currentText.id,
              src: text,
            })
          );
      }
    };

    const handleChangeColorComplete = (c, edit = true) => {
      var data;
      if (edit !== false) data = "#" + rgbHex(c.rgb.r, c.rgb.g, c.rgb.b);
      else data = c;
      setColor(data);
      dispatch(setTextColor(data));
      if (active === "text" || active === "date")
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              textColor: data,
            })
          );
        }
    };
    const handleChangeShadowColorComplete = (c, edit = true) => {
      var data;
      if (edit !== false) data = "#" + rgbHex(c.rgb.r, c.rgb.g, c.rgb.b);
      else data = c;
      setShadowColor(data);
      dispatch(setTextShadowColor(data));
      if (active === "text" || active === "date")
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              shadowColor: data,
            })
          );
        }
    };

    const handleChangeShadowEnable = (event) => {
      let data = event.target.checked;
      setShadowColorEnable(data);
      dispatch(setEnableTextShadowColor(data));
      if (active === "text" || active === "date")
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              enableShadowColor: data,
            })
          );
        }
    };

    const alignItem = (enumAlign) => {
      if (active === "text" || active === "date") {
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              alignEnable: enumAlign,
            })
          );
        }
      } else if (active === "image" || active === "signature") {
        if (activeItem) {
          dispatch(
            changeItemProperties({
              id: image.id,
              alignEnable: enumAlign,
            })
          );
        }
      }
    };

    const textalign = (alignment) => {
      if (active === "text" || active === "date") {
        if (currentText) {
          dispatch(
            changeItemProperties({
              id: currentText.id,
              textAlign: alignment,
            })
          );
        }
      }
    };

    useEffect(() => {
      const timer = setTimeout(() => {
        if (currentText)
          dispatch(
            changeItemProperties({
              id: currentText.id,
              src: text,
            })
          );
      }, 100);

      return () => clearTimeout(timer);
    }, [text]);

    const textExtension = (
      <div className="text_component text_15 productSansLight px-0 my-3 py-1">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            ref.current.addNewItem();
          }}
        >
          <Form.Group className="mb-3 pb-1">
            <Form.Label>{text ? "Edit Text" : "Enter Text"}</Form.Label>
            <Form.Control
              size="sm"
              as={currentText && currentText.multiLine ? "textarea" : "input"}
              className="text_bg"
              onChange={(e) => {
                if (e.target.value === "") {
                  dispatch(
                    deleteItem({
                      id: waterMarksState.activeId,
                    })
                  );
                  dispatch(setActiveId(""));
                  setActive("");
                  return;
                }
                setTextValue(e.target.value);
              }}
              // onKeyDown={(e) => {
              //   if (e.key === "Enter" && !e.shiftKey) {
              //     e.preventDefault(); // Prevents the default behavior (adding a new line)
              //     dispatch(
              //       changeItemProperties({
              //         id: currentText.id,
              //         src: e.target.value,
              //       })
              //     );
              //   }
              // }}
              type="text"
              value={text}
              placeholder={t("ImageProps.TypeText")}
            />
          </Form.Group>
        </Form>
        <Form.Label>Text Style</Form.Label>
        <Form.Select
          style={{ fontFamily: font }}
          size="sm"
          value={font}
          onChange={handleChange}
          aria-label="Default select example"
        >
          {fontList.map((font, index) => (
            <option style={{ fontFamily: font }} key={index} value={font}>
              {font}
            </option>
          ))}
        </Form.Select>

        <Row
          className="text_15 productSansLight m-0 p-0 mt-3 pt-1 colors
      d-flex justify-content-between flex-nowrap align-items-center
      "
        >
          {currentText && currentText.multiLine && (
            <Col md={4} className="m-0 p-0 me-1">
              <Col className="w_max">{t("ImageProps.alignment")}</Col>
              <Row className="m-0 p-0 mt-2">
                <Col
                  md={3}
                  className={`text_box_holder  ${
                    currentText &&
                    currentText.textAlign === "left" &&
                    "text_box_holder_selected"
                  } d-flex align-items-center justify-content-center`}
                  onClick={() => textalign("left")}
                >
                  <img
                    alt="currently selected"
                    src={
                      currentText && currentText.textAlign === "left"
                        ? right_text_selected
                        : right_text
                    }
                    className={`text_box pointer`}
                  />
                </Col>
                <Col
                  md={3}
                  className={`text_box_holder ${
                    currentText &&
                    currentText.textAlign === "center" &&
                    "text_box_holder_selected"
                  } mx-1 mx-xxl-2  d-flex align-items-center justify-content-center`}
                  onClick={() => textalign("center")}
                >
                  <img
                    alt="Alignment"
                    src={
                      currentText && currentText.textAlign === "center"
                        ? text_center_selected
                        : text_center
                    }
                    className="text_box pointer"
                  />
                </Col>
                <Col
                  md={3}
                  className={`text_box_holder ${
                    currentText &&
                    currentText.textAlign === "right" &&
                    "text_box_holder_selected"
                  } d-flex align-items-center justify-content-center`}
                  onClick={() => textalign("right")}
                >
                  <img
                    alt="alignment"
                    src={
                      currentText && currentText.textAlign === "right"
                        ? left_text_selected
                        : left_text
                    }
                    className="text_box pointer"
                  />
                </Col>
              </Row>
            </Col>
          )}
          <Col
            className={`m-0 p-0 ${
              currentText && currentText.multiLine && "ps-4"
            } color_width`}
            md={8}
          >
            <Col className="w_max ">{t("ImageProps.color")}</Col>
            <Row className="justify-content-start  m-0 p-0 mt-2 p-2 flex-nowrap color_bg text_15 Aktiv">
              <Col
                md={3}
                className="color_sec m-0 rounded"
                id="id"
                style={{ backgroundColor: `${color}` }}
                onClick={(event) => {
                  setAnchorEl(event.currentTarget);
                }}
              ></Col>
              <Col className="w_max m-0 p-0 ms-3 ">
                {
                  <Form>
                    {" "}
                    {/* className='m-0 p-0 px-1' */}
                    <Form.Control
                      className="m-0 p-0 px-1"
                      type="text"
                      value={color}
                      onChange={(e) =>
                        handleChangeColorComplete(e.target.value, false)
                      }
                    />
                  </Form>
                }
              </Col>
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                onClose={() => setAnchorEl(null)}
              >
                <ChromePicker
                  width={300}
                  color={color}
                  onChange={handleChangeColorComplete}
                />
              </Popover>
            </Row>
          </Col>
        </Row>

        {/*  */}

        <div className="colors d-flex align-items-center mt-3 pt-1 mb-2">
          <p className="p-0 m-0">Enable Shadow Color</p>
          <FormGroup sx={{ p: 0, m: 0 }}>
            <FormControlLabel
              control={
                <SwitchCustom
                  checked={shadowColorEnable}
                  onChange={(checked) => handleChangeShadowEnable(checked)}
                  sx={{ p: 0, m: 0 }}
                />
              }
            />
          </FormGroup>
          {/* <Switch
          checked={shadowColorEnable}
          onColor="#F2526F"
          onChange={checked => handleChangeShadowEnable(checked)}
        /> */}
        </div>

        {shadowColorEnable === true ? (
          <div className="colors">
            <Col className="m-0 p-0 color_width">
              <Row className="justify-content-start mb-1 m-0 p-0 p-2 flex-nowrap color_bg text_15 Aktiv">
                <Col
                  md={3}
                  className="color_sec m-0 rounded"
                  id="id"
                  style={{ backgroundColor: `${shadowColor}` }}
                  onClick={(event) => {
                    setAnchorEl2(event.currentTarget);
                  }}
                ></Col>
                <Col className="w_max m-0 p-0 ms-3 ">
                  <Form>
                    <Form.Control
                      className="m-0 p-0 px-1"
                      type="text"
                      value={shadowColor}
                      onChange={(e) =>
                        handleChangeShadowColorComplete(e.target.value, false)
                      }
                    />
                  </Form>
                </Col>
                <Popover
                  open={Boolean(anchorEl2)}
                  anchorEl={anchorEl2}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  onClose={() => setAnchorEl2(null)}
                >
                  <ChromePicker
                    width={300}
                    color={shadowColor}
                    onChange={handleChangeShadowColorComplete}
                  />
                </Popover>
              </Row>
            </Col>
          </div>
        ) : null}
      </div>
    );

    return (
      <Col
        className={`image_properties newScroller px-4 mt-3 ${
          isVisible ? "visible" : "hidden"
        }`}
      >
        {active && (
          <Row
            className=" head border-bottom m-0 mx-2 line_height_100pc text_18 text-uppercase
      d-flex justify-content-start align-items-start
      "
          >
            {" "}
            <p className="productSansBold mt-1 m-0 px-0 mb-3">
              {active === "image"
                ? "Image Properties"
                : active === "text"
                ? "Text Watermark"
                : active === "signature"
                ? "SIGNATURE WATERMARK"
                : active === "date"
                ? "Date Properties"
                : active === "sticker"
                ? "Sticker Watermark"
                : active === "template"
                ? "Templates"
                : null}
            </p>
          </Row>
        )}
        {!userSliceState.template_Edit || !file.batchurls.length ? (
          <Row
            className={`${
              active === "sticker" ||
              active === "image" ||
              active === "signature" ||
              active === "template"
                ? "border-0 borderbottom "
                : "borderbottom"
            } m-0
      d-flex justify-content-center align-items-center mx-2 `}
          >
            {" "}
            {/* ${active !== "sticker" && "px-4"} */}
            {active === "text" || active === "date" ? (
              textExtension
            ) : active === "sticker" ? (
              <Stickers />
            ) : active === "template" ? (
              <Templates active={active === "template"} />
            ) : null}
          </Row>
        ) : null}
        {active === "sticker" ? null : currentText || image ? (
          <>
            <SlidersRow
              text={currentText ? true : false}
              size={size}
              sizeScale={sizeScale}
              sizeChanged={sizeChanged}
              rotation={rotation}
              rotate={rotate}
              opacity={opacity}
              changeOpacity={changeOpacity}
              src={image ? image : currentText}
              fileState={file}
              userSliceState={userSliceState}
            />

            <AlignmentRow
              // alignTopLeft={alignTopLeft}
              alignItem={alignItem}
              Enum={EnumAlign}
            />
          </>
        ) : null}

        {/* <DateTime setOpen={setOpen} open={open} /> */}
        {/* <Signature onSignatureApply={onSignatureApply} setActive={setActive} openSignature={openSignature} setOpenSignature={setOpenSignature} /> */}
      </Col>
    );
  }
);

ImageProperties.displayName = "ImageProperties";

export default ImageProperties;
